import React from "react"

import { ProductSearchHelper } from "../../helpers"
import { ListingList } from "./index.jsx"

const LatestListingList = ({
  limit = 4
}) => {
    return (
        <ListingList
            {...ProductSearchHelper.prepareForServer({})}
            limit={limit}
            firstPageOnly
        />
    )
}

export default LatestListingList